import FoodItemCardList, { FoodItemCardListProps } from './FoodItemCardList';

export type { FoodItemCardListProps };
export default FoodItemCardList;
